import { Pencil } from "lucide-react";
import type { PatronCategory } from "@/api/types";
import { Button } from "@/components/ui/button";
import { CATEGORY_TYPE_LABELS } from "../../patronCategories";

/** Who the selected category is for, above its rules. */
export function CategoryIdentity({
  category,
  onEdit,
}: {
  category: PatronCategory;
  onEdit: () => void;
}) {
  return (
    <section
      aria-labelledby="category-identity-title"
      className="flex flex-wrap items-start justify-between gap-4 rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800"
    >
      <div className="min-w-0">
        <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-gray-500 dark:text-gray-400">
          <span className="font-mono tracking-wider">{category.code}</span>
          <span aria-hidden>·</span>
          <span>{CATEGORY_TYPE_LABELS[category.type]}</span>
          {!category.active && (
            <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] text-gray-600 dark:bg-gray-700 dark:text-gray-300">
              inactive — non proposée à l&apos;inscription
            </span>
          )}
        </p>
        <h2
          id="category-identity-title"
          className="mt-1 text-xl font-semibold tracking-tight break-words text-gray-900 dark:text-white"
        >
          {category.name}
        </h2>
        {category.description && (
          <p className="mt-1 max-w-2xl text-sm whitespace-pre-line text-gray-600 dark:text-gray-300">
            {category.description}
          </p>
        )}
      </div>
      <Button type="button" variant="outline" onClick={onEdit}>
        <Pencil aria-hidden />
        Modifier
      </Button>
    </section>
  );
}
